import React, {useEffect, useState} from 'react';
import {useNavigate, Outlet, useLocation} from 'react-router-dom';
import { Tabs, TabList, Tab } from '@chakra-ui/react'

export default function Navbar ({routes}) {

  const  {pathname} = useLocation();
  const navigate = useNavigate();
  const [index,setIndex] = useState(1);

  useEffect(()=>{

    routes.map((object,_index)=>{
      const {route} = object;
      if(route===pathname) {
        setIndex(_index)
      }
      return object;
    })
  }, [routes, pathname])

  const goTo = (route) =>{
    navigate(route);
  }



  return ( //COLORES DE LOS TITULOS Y MENUS DENTRO DE LAS PAGINAS
    <>
    <Tabs style={{marginBottom:'1rem'}} variant='soft-rounded' index={index} colorScheme='rgb(247, 147, 26);'>
        <TabList >
          {routes && routes.map(({name,route}, key)=>
            (<Tab style={{color:'#FFFFFF'}} key={key} onClick={()=>goTo(route)} >{name} </Tab>)
          )}
        </TabList>
      </Tabs>

    <Outlet />

    </>
  )
}
